import type { FaireProductEntity } from "../../entity_types/product";

export const p_477azebnn4: FaireProductEntity = {
  token: "p_477azebnn4",
  type: "product",
  name: "Halloween Edition Maltose Sugar Squeeze - Trick or Treat",
  brandToken: "b_b8csz3xa8h",
  brandName: "Gypsy Soul",
  imageUrl:
    "https://cdn.faire.com/fastly/7633fa764c7db5bf7ec017be6650b9c6ed425b9cd3a1c3c3f5c6fa60e0d86248.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5018255d0b0a852b5f4ad3868cae24d232a16d21230dfdd1dc87502e9d3f1420.png",
    "https://cdn.faire.com/fastly/6b716c568e7408c70ec14f4f8ed3d7bf5d83307149cecbb733c6a9b0f836bbde.png",
    "https://cdn.faire.com/fastly/6ed7fbd604ff35990181ea339cb896a605765a8e4ac7a3a41c00dc957f527ad4.png",
  ],
  priceDollars: 7.49,
  description:
    "Meet the Halloween Edition Maltose Sugar Squeeze—a spooky, super solid squish that’s sugar-filled, satisfying, and made for Halloween impulse sales. With fun Halloween characters (like pumpkin, bat, and ghost) and a “Trick or Treat” display, this is an easy seasonal win for checkout counters and trend tables.\n\nWhat’s Included\n12pcs per display\nCountertop display included (as shown)\nAssorted Halloween character styles (mix may vary)\nMaltose-filled “sugar squeeze” style squish (as shown)\n\nWhy It Sells\nHalloween seasonal item = fast sell-through 🛒\nSuper solid squish + sticky maltose feel = addictive fidget\nCute spooky designs make it giftable and collectible\nPerfect for party favors, prizes, and Halloween baskets\n\nShips quickly - Limited stock",
  tags: [],
  msrpDollars: 14.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:34.759Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
